import router from '../router';
// import { mergeThreadViews } from '@/components/thread/thread-tracker';
// import { observeTwigViews } from './inview';
import { observeTrackTargets } from './target';
import { track } from './broker';
import './directive';
export { track };

export function initTracking() {
  // don't init before router is ready as we track the current route name
  router.isReady().then(() => {
    // addInterceptor(mergeThreadViews);
    observeTrackTargets(track);
    // observeTwigViews();
  });
}
